var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-tour',{attrs:{"callbacks":{ onStart: _vm.onStart, onFinish: _vm.onFinish },"name":"tourAfterCreateOrder","steps":_vm.steps,"options":{ labels: { buttonStop: _vm.$t('gotIt') } }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }